export default __webpack_public_path__ + "static/media/adults.4edd3c9c.png";